import React, { useEffect } from 'react';
import styled from 'styled-components';
import { colors, layout } from 'Constants';

import {
  Container,
  Header,
  Icon,
  Anchor,
  Button,
  Footnote
} from 'Components/core';

import InfoBox from 'Components/InfoBox';
import ReadyToEnroll from 'Views/benefits/components/ReadyToEnroll';

// Images
import HMO from './images/hmo.jpg';
import PPO from './images/Dental_Benefits_-_Dental_PPO.jpeg';
import DentalManagedCare from './images/dental-managed-care.jpg';
import DentalTools from './images/dental-tools.jpg';

import { Subscribe } from 'laco-react';
import { ApiStore } from 'Store';
import Table from './components/Table';
import CODES from 'Root/libs/analytics/CodeDef';
import Api from 'Root/libs/analytics/Api';
import { replaceAnchor } from 'Root/libs/anchor';
import { HeaderV2, SubHeader, TitleHeader } from 'Components/core/Header';
import CardContainer from 'Components/Card/CardContainer';
import Card from 'Components/Card';
import Heart from './images/heart.svg';
import Tooth from './images/tooth.svg';
import DentalCost from './images/dentalcost.svg';
import DentalCopy from './images/dentalcopy.svg';
import BigTooth from './images/bigtooth.svg';

export default () => {
  useEffect(() => {
    Api.recordAcitity(CODES.MENU_DENTAL_BENIFITS);
  }, []);

  return (
    <Subscribe to={[ApiStore]}>
      {state => {
        let HMOSection = state.dental?.dentalPlans?.planDental?.find(
          a => a.type == 'HMO'
        );
        let PPOSection = state.dental?.dentalPlans?.planDental?.find(
          a => a.type == 'PPO'
        );
        let managedCareSection = state.dental?.dentalPlans?.planDental?.find(
          a => a.type == 'Managed Care'
        );

        return (
          <Container
            seperation="24px"
            column
            maxWidth
            style={{ margin: 'auto' }}
          >
            <HeaderV2
              title={'Dental Benefits'}
              text={
                <>
                  {!state.dental.summary && (
                    <p>
                      Dental benefits not only protect your teeth, but also can
                      support your overall health. Some conditions, like heart
                      disease, can have warning signs in the mouth and gums.
                      <sup>1</sup>
                    </p>
                  )}
                  {state.dental.summary && (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: replaceAnchor(state.dental.summary)
                      }}
                    ></div>
                  )}
                </>
              }
            ></HeaderV2>

            <Table />

            {HMOSection && (
              <InfoBox header="Dental HMO" image={HMO}>
                {/* TODO: Replace with RRD data when it is made avaliable */}

                {HMOSection?.highlights && (
                  <p
                    dangerouslySetInnerHTML={{
                      __html: replaceAnchor(HMOSection?.highlights)
                    }}
                  ></p>
                )}

                {!HMOSection?.highlights && (
                  <React.Fragment>
                    <p>
                      Dental benefits not only protect your teeth, but can
                      support overall health, too. Some conditions like heart
                      disease, for example, can have warning signs in the mouth
                      and gums. Our dental plan gives you all the benefits you
                      need for a healthy mouth and more.
                    </p>

                    <p>
                      Visit{' '}
                      <Anchor
                        code={CODES.DN_BFT_HMO_VD}
                        to={'https://' + HMOSection.videoLink}
                      >
                        {HMOSection.videoLink}
                      </Anchor>{' '}
                      to watch a video and learn more about a dental HMO plan.
                    </p>
                    <p>
                      <span>Your dental plan covers:</span>
                      <ul>
                        <li>
                          Most preventive and diagnostic services at 100% when
                          you see a dentist in the plan. That includes things
                          like cleanings, exams and X-rays.
                        </li>
                        <li>
                          {' '}
                          Periodontal maintenance and fluoride treatments.
                        </li>
                        <li> Teeth whitening and veneers.</li>
                      </ul>
                    </p>

                    <p>
                      <span>
                        Get the <b>{state.mobileAppInfo?.appName}</b> mobile app
                        or visit{' '}
                        <Anchor
                          code={CODES.DN_BFT_HMO_WEB}
                          to={'https://' + HMOSection.website}
                        >
                          {HMOSection.website}
                        </Anchor>{' '}
                        to:
                      </span>
                      <ul>
                        <li>Find a dentist in your plan and pay less.</li>
                        <li>
                          Order extra ID cards or use your mobile ID card
                          through the mobile app.
                        </li>
                      </ul>
                    </p>
                  </React.Fragment>
                )}
              </InfoBox>
            )}
            {PPOSection && (
              <DentalPPOContainer header="Dental PPO" column image={PPO}>
                <TitleHeader style={{ display: 'block', textAlign: 'left' }}>
                  Dental PPO
                </TitleHeader>

                {PPOSection?.highlights && (
                  <p
                    dangerouslySetInnerHTML={{
                      __html: replaceAnchor(PPOSection?.highlights)
                    }}
                  ></p>
                )}

                {!PPOSection?.highlights && (
                  <React.Fragment>
                    <p>
                      Dental benefits not only protect your teeth, but can
                      support overall health, too. Some conditions like heart
                      disease, for example, can have warning signs in the mouth
                      and gums. Our dental plan gives you all the benefits you
                      need for a healthy mouth and more.
                    </p>
                    <p>
                      Visit{' '}
                      <Anchor
                        code={CODES.DN_BFT_PPO_VD}
                        to={'https://' + PPOSection.videoLink}
                      >
                        {PPOSection.videoLink}
                      </Anchor>{' '}
                      to watch a video and learn more about a dental PPO plan.
                    </p>
                    <p>
                      <span>Your dental plan benefits cover:</span>
                      <ul>
                        <li>
                          Most preventive and diagnostic services at 100%. That
                          includes things like cleanings and X-rays.
                        </li>
                        <li>
                          More dental services, including an extra periodontal
                          cleaning if you’re enrolled in certain care management
                          programs.
                        </li>
                      </ul>
                    </p>

                    <p>
                      <span>
                        Get the <b>{state.mobileAppInfo?.appName}</b> mobile app
                        or visit{' '}
                        <Anchor
                          code={CODES.DN_BFT_PPO_WEB}
                          to={'https://' + PPOSection.website}
                        >
                          {PPOSection.website}
                        </Anchor>{' '}
                        to:
                      </span>
                      <ul>
                        <li>Find a dentist in your plan and pay less.</li>
                        <li>Use your digital ID card.</li>
                        <li>Find out the status of a claim.</li>
                        <li>
                          {' '}
                          Get a health score for your gums and teeth using our
                          Dental Health Assessment tool.
                        </li>
                        <li>
                          {' '}
                          Email a dental hygienist your dental questions through
                          our Ask a Hygienist tool.
                        </li>
                      </ul>
                    </p>
                  </React.Fragment>
                )}
              </DentalPPOContainer>
            )}
            {false && <CardContainer
              style={{
                maxWidth: 1128,
                justifyContent: 'space-around',
                alignSelf: 'center',
                paddingBottom: 40,
                
              }}
            >
              <Card>
                <div>
                  <img
                    alt="Find Care"
                    src={Heart}
                    style={{ width: '44px', height: '44px' }}
                  />
                </div>
                <Header>
                  <span style={headerStyle}>Find care</span>
                </Header>
                <p>
                  Search for dental treatments and dentists in your plan’s
                  network and compare costs.{' '}
                </p>
              </Card>

              <Card>
                <div>
                  <img
                    src={Tooth}
                    alt="Ask a Hygienist"
                    style={{ width: '44px', height: '44px' }}
                  />
                </div>
                <Header>
                  <span style={headerStyle}>Ask a hygienist</span>
                </Header>
                <p>
                  {' '}
                  Email questions and get a response within 24 to 48 hours from
                  a team of licensed dental professionals.{' '}
                </p>
              </Card>

              <Card>
                <div>
                  <img
                    alt="Find Care"
                    src={DentalCost}
                    style={{ width: '44px', height: '44px' }}
                  />
                </div>
                <Header>
                  <span style={headerStyle}>Dental cost estimator</span>
                </Header>
                <p>
                  Estimate the cost of common dental procedures if you see a
                  dentist in or out of your plan’s network.{' '}
                </p>
              </Card>

              <Card>
                <div>
                  <img
                    src={DentalCopy}
                    alt="Dental Health Assessment"
                    style={{ width: '44px', height: '44px' }}
                  />
                </div>
                <Header>
                  <span style={headerStyle}>Dental health assessment</span>
                </Header>
                <p>
                  Answer questions to better understand your dental health and
                  risk of developing tooth decay, gum disease, and oral cancer.{' '}
                </p>
              </Card>
            </CardContainer>}

            {managedCareSection && (
              <InfoBox header="Dental Managed Care" image={DentalManagedCare}>
                {managedCareSection?.highlights && (
                  <p
                    dangerouslySetInnerHTML={{
                      __html: replaceAnchor(managedCareSection?.highlights)
                    }}
                  ></p>
                )}
                {!managedCareSection.highlights && (
                  <React.Fragment>
                    <p>
                      Dental benefits not only protect your teeth, but can
                      support overall health, too. Some conditions like heart
                      disease, for example, can have warning signs in the mouth
                      and gums. Our dental plan gives you all the benefits you
                      need for a healthy mouth and more.
                    </p>
                    <p>
                      <span>Your dental plan covers:</span>
                      <ul>
                        <li>
                          Most preventive and diagnostic services at 100%. That
                          includes things like cleanings, exams and X-rays.
                        </li>
                        <li>
                          Unlimited cleanings, periodontal maintenance and
                          fluoride treatments.
                        </li>
                        <li>Teeth whitening and veneers.</li>

                        <li>
                          Covers over 500 procedures – the most comprehensive
                          coverage available.
                        </li>
                      </ul>
                    </p>
                    <p>
                      <span>The Managed Care plan:</span>
                      <ul>
                        <li>Has low copays, so you'll save money. </li>
                        <li>
                          Includes lab fees, so there are no surprises or
                          unexpected lab expenses.
                        </li>
                        <li>
                          Includes primary care dentists who will guide your
                          care for the best outcomes.
                        </li>
                      </ul>
                    </p>
                    <p>
                      <span>
                        Get the <b>{state.mobileAppInfo?.appName}</b> mobile app
                        or visit{' '}
                        <Anchor
                          code={CODES.DN_BFT_MC_WEB}
                          to={'https://' + managedCareSection.website}
                        >
                          {managedCareSection.website}
                        </Anchor>{' '}
                        to:
                      </span>
                      <ul>
                        <li>Find a dentist in your plan and pay less.</li>
                        <li>Use your digital ID card.</li>
                      </ul>
                    </p>
                  </React.Fragment>
                )}
              </InfoBox>
            )}
            <InfoBox
              header="Dental Tools That Won't Hurt a Bit"
              image={DentalTools}
            >
              <p>
                Your plan comes with handy tools to help you get the best care
                and save money:
              </p>
              <ul>
                <li>
                  <b>Dental Care Cost Estimator:</b> Lets you estimate common
                  dental procedures and treatments.
                </li>
                <li>
                  <b>The right dentist can make all the difference</b> - and
                  choosing one in your plan can save you money, too. Use our
                  <Anchor
                    code={CODES.MED_BFT_FIND_DOC}
                    to={state.doctorURL.link}
                  >
                    {' '}
                    Find Care tool
                  </Anchor>{' '}
                  on{' '}
                  <Anchor
                    code={CODES.DN_BFT_TOOLS_WEB}
                    to={state.brandInfo.webLink}
                  >
                    {state.brandInfo.website}
                  </Anchor>
                  .
                </li>
              </ul>
            </InfoBox>

            <DentalHeroContainer
              style={{
                backgroundColor: '#1355E9',
               
              }}
              row
            >
              <Container
                column
                style={{
                  justifyContent: 'center',
                  alignItems: 'center',
                  textAlign: 'center'
                }}
                flex={1}
              >
                <DentalHeroText style={{ alignSelf: 'center' }}>
                  <p>Dental health is important to your overall health.</p>
                  <p>
                    Did you know that regular dental checkups aren’t only good
                    for your teeth? They can also detect health issues like
                    autoimmune diseases, diabetes, and heart disease.
                  </p>
                </DentalHeroText>
              </Container>
              <DentalHeroImageContainer style={{justifyContent:'center',alignItems:'center'}}>
                <img src={BigTooth} style={{ height: 251 }} />
              </DentalHeroImageContainer>
            </DentalHeroContainer>
            {false && <ReadyToEnroll />}
            {!state.dental.summary && (
              <Footnote center>
                1 American Heart Association, Middle-aged tooth loss linked to
                increased coronary heart disease risk (accessed February 2019):{' '}
                <Anchor
                  code={CODES.DN_FOOTER_HTN}
                  to="https://newsroom.heart.org"
                >
                  newsroom.heart.org.
                </Anchor>
              </Footnote>
            )}
          </Container>
        );
      }}
    </Subscribe>
  );
};

const headerStyle = {
  fontFamily: 'Elevance Sans Semibold',
  fontSize: 24,

  color: '#333'
};

const DentalPPOContainer = styled(Container)`
  padding: 0px 118px 0px 118px;
 
  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    padding: 10px;
  }
`;

const DentalHeroText = styled.div`
  font-family: 'Elevance Sans Regular';
  font-weight: 500;
  font-size: 24px;
  line-height: 36px;
  text-align: center;
  color: #fff;
  width: 552px; 
 
  @media screen and (max-width: ${layout.breakpoints.mobile}) {
   width:95vw;
  }
`;


const DentalHeroContainer=styled(Container)`
 padding: 60px 215px 60px 215px;
 flex-wrap:wrap ;
 @media screen and (max-width: ${layout.breakpoints.mobile}) {
   padding: 20px;
   
   
  }

`;


const DentalHeroImageContainer=styled(Container)`
 @media screen and (max-width: ${layout.breakpoints.mobile}) {
  width:100%;
 }
`;
